export const REGEX_VALID_NUMBER = {
  INTEGER: new RegExp("^\\-?\\d*$"),
  POSITIVE_INTEGER: new RegExp("^\\d*$"),
  DOUBLE: new RegExp("^\\-?(\\d+\\.)?\\d*$"),
  POSITIVE_DOUBLE: new RegExp("^(\\d+\\.)?\\d*$")
};

export const REGEX_EXTRACT_HTML_TAG_CONTENT = new RegExp("<.*>([^<>]*)<.*>");
export const REGEX_REPLACE_HTML_TAG = /<[^>]+>/g;
export const REGEX_VALIDATE_EMAIL = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
export const REGEX_NORMALIZE_TEXT = /[.,\/#!$%\^&\*;:{}=\-_`~()\s]/g;
export const REGEX_MATCH_TEXT_FIELD = /^\[\[field(\d+)\]\]$/;
export const REGEX_SPLIT_FIELD = /(\[\[field\d+\]\]|\[\[x[^\]]*\]\])/;

export const REGEX_EXTRACT_FIELD_TAGS = /\[\[[^\]]+\]\]/g;
export const REGEX_EXTRACT_FIELD_SUB_TAGS = /\{\{[^\}]+\}\}/g;
export const REGEX_EXTRACT_CHECKBOX_PARENT_OPTION = /data\-parent="(\d+)"/;



// WEBPACK FOOTER //
// ./src/constants/regex.js